const TopBanner: React.FC = () => {
  return (
    <div className="bg-primary text-sm md:text-base myContainer h-16 md:h-14 flex justify-center text-center items-center text-white">
      <p>
        Unmasking the Layers of Confidentiality in Cutting-Edge AI Technologies
      </p>
    </div>
  );
};

export default TopBanner;
